/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengeRewardNotificationActionData
 */
export interface ChallengeRewardNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof ChallengeRewardNotificationActionData
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeRewardNotificationActionData
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeRewardNotificationActionData
     */
    challengeId: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeRewardNotificationActionData
     */
    listenStreak?: number;
}

/**
 * Check if a given object implements the ChallengeRewardNotificationActionData interface.
 */
export function instanceOfChallengeRewardNotificationActionData(value: object): value is ChallengeRewardNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "amount" in value && value["amount"] !== undefined;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "challengeId" in value && value["challengeId"] !== undefined;

    return isInstance;
}

export function ChallengeRewardNotificationActionDataFromJSON(json: any): ChallengeRewardNotificationActionData {
    return ChallengeRewardNotificationActionDataFromJSONTyped(json, false);
}

export function ChallengeRewardNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeRewardNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'specifier': json['specifier'],
        'challengeId': json['challenge_id'],
        'listenStreak': !exists(json, 'listen_streak') ? undefined : json['listen_streak'],
    };
}

export function ChallengeRewardNotificationActionDataToJSON(value?: ChallengeRewardNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'specifier': value.specifier,
        'challenge_id': value.challengeId,
        'listen_streak': value.listenStreak,
    };
}

